import { Post } from 'model';
import { FormValidationRules } from '../hooks/useFormValues';

export const CommunityQuestionEditRules: FormValidationRules<Post> = {
	topic: {
		rules: {
			required: {
				value: true,
				message: 'Question Topic is required'
			},
			maxLength: {
				value: 20,
				message: 'Must be less than {value} characters'
			},
			pattern: {
				value: /^\S*$/,
				message: 'Must be one word'
			}
		}
	},
	title: {
		rules: {
			maxLength: {
				value: 80,
				message: 'Must be less than {value} characters'
			},
			minLength: {
				value: 10,
				message: 'Must be more than {value} characters'
			},
			required: {
				value: true,
				message: 'Question is required'
			}
		}
	}
};
